import { render } from "./LayoutContent.vue?vue&type=template&id=c9c9311c&scoped=true"
import script from "./LayoutContent.vue?vue&type=script&lang=js"
export * from "./LayoutContent.vue?vue&type=script&lang=js"

import "./LayoutContent.vue?vue&type=style&index=0&id=c9c9311c&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c9311c"]])

export default __exports__